<template>
  <img v-if="image"
    :class="readyToGo || loaded ? 'show' : 'hide'"
    :srcset="readyToGo || loaded ? crossOriginSRCSET(image.srcset) : null"
    :sizes="sizes || '50vw'"
    @load="load" />
</template>

<script setup>
import { defineProps, computed } from 'vue';
const props = defineProps(['context', 'filename', 'id','sizes']);
const images = computed(() => props.context?.images || null);
const method = computed(() => props.filename?.trim() ? 'filename' : props.id?.trim() ? 'id' : null);
const identity = computed(() => props[method.value]?.trim());
const image = computed(() => images.value?.find(obj => obj[method.value] === identity.value) || null);

// Use the store
import { crossOriginSRCSET } from '@/utils';
import { useImageStore } from './ImageStore';
const imageStore = useImageStore();
const ticket = imageStore.ticket();
const loaded = ref(false);
const readyToGo = computed(() => imageStore.loadedImages.includes(image.value.url) || ticket <= imageStore.currentInQueue );
const emit = defineEmits(['image-loaded']);

const load = () => {
  if(!loaded.value) imageStore.loaded(image.value?.url);
  if(!loaded.value) imageStore.nextInQueue();
  loaded.value = true;
  emit('image-loaded');
}
//After 0.3 second grace period load the image anyway.
setTimeout(() => load(), 300);
</script>

<style scoped>
  img {
    transition: opacity 0.3s ease-in-out;
  }

  img.show {
    opacity: 1;
  }

  img.hide {
    opacity: 0.3;
  }
</style>
